import React, { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { CourseLesson } from '../../components/CourseLesson';

export function CourseLessonPage() {
  const { name } = useParams();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  return (
    <CourseLesson name={name} />
  );
}
